// src/v2/pages/Reports/ReportR1A.js
import React from 'react';
import { GeneralMessage } from '../../../common/APICommon';
import { useReportR1A } from '../../hooks/useReportR1A';
import { ReportR1AModule } from '../../components/modules/Reports/ReportR1A/ReportR1AModule';

const ReportR1A = ({ isHideSideMenu }) => {
  const reportHook = useReportR1A();

  return (
    <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
      <div className="LeftSpace"></div>
      <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
        <ReportR1AModule reportHook={reportHook} />
      </div>
      <GeneralMessage form={reportHook.showMessage} message={reportHook.message} isSuccess={reportHook.isSuccess} />
    </div>
  );
};

export default ReportR1A;